import React from 'react'
import AppDoughnutChart from './AppDoughnutChart';

function DocumentPieChart({report}) {

    const dataLabels = [];
    const chartData = [];

   report.department.forEach(department=>{
        if(department.label!=="Total"){
            dataLabels.push(department.label+" ("+department.count+")");
            chartData.push(department.count);
        }
    })


    
    return (
      <>
      <AppDoughnutChart dataLabels={dataLabels} chartData={chartData} />
      </>
    )
}

export default DocumentPieChart
